<template>
    <div>
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>
            <b-table
                responsive
                small
                :items="filteredItems"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="['search']"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                primary-key="client_id"
                @filtered="onFiltered"
            >
                <template #cell(debit)="data">
                    {{ formatNumber(data.item.debit) }}
                </template>
                <template #cell(credit)="data">
                    {{ formatNumber(data.item.credit) }}
                </template>
            </b-table>
            <!-- Pagination -->
            <b-row>
                <b-col md="3" class="my-1 text-center">
                    <b-pagination
                        v-if="totalRows > 0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"
                        size="sm"
                    ></b-pagination>
                </b-col>
                <b-col md="6" class="my-2">
                    <p class="text-center small pt-0">{{ legend }}</p>
                </b-col>
                <b-col md="3" class="my-1 text-right">
                    <b-dropdown
                        right
                        split
                        size="sm"
                        :text="perPage + ' éléments par page'"
                    >
                        <b-dropdown-item
                            v-for="pageOption in pageOptions"
                            :key="pageOption"
                            @click="setPerPage(pageOption)"
                        >
                            {{ pageOption }}
                        </b-dropdown-item>
                    </b-dropdown>
                </b-col>
            </b-row>
            <!-- /Pagination -->
        </div>
        <b-button variant="primary" @click="process">
            Relancer l'importation
        </b-button>
    </div>
</template>

<script>
import loading from '../../common/components/loading.vue'
import TableHandler from '../../common/mixins/TableHandler.vue'
import DashboardHandler from '../../dashboard/mixins/DashboardHandler.vue'

export default {
    name: 'TableFeesImportationErrors',

    components: {
        loading,
    },

    mixins: [TableHandler, DashboardHandler],
    data() {
        return {
            fields: [
                {key: 'entry_date', label: 'Date', sortable: true},
                {key: 'account_number', label: 'Compte', sortable: true},
                {
                    key: 'accounting_firm_company_code',
                    label: 'Cabinet',
                    sortable: true,
                },
                {key: 'short_name', label: 'Nom court', sortable: true},
                {key: 'entry_piece', label: 'N° pièce', sortable: true},
                {key: 'entry_description', label: 'Libellé', sortable: true},
                {
                    key: 'debit',
                    label: 'Débit',
                    class: 'text-right',
                    sortable: true,
                },
                {
                    key: 'credit',
                    label: 'Crédit',
                    class: 'text-right',
                    sortable: true,
                },
                {
                    key: 'importation_comments',
                    label: 'Erreur',
                    sortable: true,
                },
            ],
        }
    },

    async created() {
        await this.getData()
    },

    methods: {
        async getData() {
            this.loading = true
            try {
                const response = await axios.get('feesImportations/errors')
                this.items = response.data.data
                this.loading = false
                this.updateTotalRows()
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        formatNumber(number) {
            if (number === 0) {
                return '-'
            }
            if (number === null) {
                return '-'
            }
            return new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: 'EUR',
            }).format(number)
        },

        async process() {
            try {
                await axios.get('feesImportations/process')
                await this.getData()
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },
    },
}
</script>

<style scoped></style>
